
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 97 178","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.703 84.53a6.82 6.82 0 005.736 3.13h21.429L.826 168.348c-.374 3.218.059 6.884 3.107 8.524 1.024.549 2.707.813 3.226.813a6.82 6.82 0 005.6-2.92L94.834 57.32c1.451-2.372 1.626-5.091.451-7.343a6.82 6.82 0 00-6.047-3.665H68.132L84.38 9.91A6.82 6.82 0 0078.152.311H45.18c-2.833 0-5.26 1.56-6.368 3.992L5.232 78.12c-.961 2.004-.785 4.459.471 6.41z","fill":"#F6E94A"}})])
          )
        }
      }
    